import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[matDateTimeMask]'
})
export class MatDateTimeMaskDirective {

  constructor(private el: ElementRef<HTMLInputElement>) {}

  @HostListener('input', ['$event'])
  onInput(event: InputEvent): void {
    const input = this.el.nativeElement;
    let value = input.value.replace(/\D/g, '');

    if (value.length > 2) {
      value = value.slice(0, 2) + '/' + value.slice(2);
    }
    if (value.length > 5) {
      value = value.slice(0, 5) + '/' + value.slice(5);
    }
    if (value.length > 10) {
      value = value.slice(0, 10) + ' ' + value.slice(10);
    }
    if (value.length > 13) {
      value = value.slice(0, 13) + ':' + value.slice(13, 15);
    }
    if (value.length > 16) {
      value = value.slice(0, 16);
    }

    input.value = value;
  }

  @HostListener('blur')
  onBlur(): void {
    const input = this.el.nativeElement;
    
    if (input.value.length < 16) {
      input.value = '';
    }
  }
}